// UTILS
import { ref } from "vue"
import { defineStore } from "pinia"
import Bugsnag from "@bugsnag/js"

// STORES
import { useImportantModalStore } from "@/features/brain/components/ImportantModal/importantModal.store"
import { useBrainStore } from "@/features/brain/stores/brain.store"

export const useBrainLayoutStore = defineStore("brainLayoutStore", () => {
  const { openModal } = useImportantModalStore()

  const allowActions = ref(false)
  const isSkipAction = ref(true)
  const isConfirmAction = ref(false)

  const isResetting = ref(false)

  // User actions to track
  const trackMoves = ref(0) // how many times the user moved tokens
  const trackOversights = ref(0) // how many times the user skipped and cancelled skip modal
  const trackResets = ref(0) // how many times the user reset the test

  const instructionsDone = ref(false)

  let resetTimeout

  /**
   * Reset the current step
   */
  async function resetCurrentStep() {
    if (resetTimeout) clearTimeout(resetTimeout)
    isResetting.value = true
    resetTimeout = setTimeout(() => {
      const brain = useBrainStore()
      if (brain.isRunning) {
        brain.rawResetTest()
      } else {
        Bugsnag.notify(
          new Error("Brain instance not yet initialized"),
          (event) => {
            event.context = "Brain.resetCurrentStep"
            event.severity = "error"
            event.unhandled = true
            event.addMetadata("brain_state", {
              // Plus d'instance à remonter depuis la migration vers un store :
              // on rapporte l'indice de l'item, qui suffit à situer l'erreur.
              currentTest: useBrainStore().runner.currentTest,
            })
          }
        )
      }
      isResetting.value = false
      resetTimeout = null
    }, 1000)
  }

  /**
   * Show the skip CTA
   */
  function showSkipCTA() {
    if (isSkipAction.value) return
    isConfirmAction.value = false
    isSkipAction.value = true
  }

  /**
   * Show the confirm CTA
   */
  function showConfirmCTA() {
    if (isConfirmAction.value) return
    isConfirmAction.value = true
    isSkipAction.value = false
  }

  /**
   * Hide the CTA
   */
  function hideCTA() {
    isConfirmAction.value = false
    isSkipAction.value = false
  }

  /**
   * Skip the current step
   */
  function skipStep() {
    openModal("incompleteAnswer", {
      actionPrimary: () => {
        void useBrainStore().sendAnswer()
      },
      actionSecondary: () => trackOversights.value++,
    })
  }

  return {
    allowActions,
    instructionsDone,
    isSkipAction,
    isConfirmAction,
    resetCurrentStep,
    showSkipCTA,
    showConfirmCTA,
    hideCTA,
    skipStep,
    trackMoves,
    trackOversights,
    trackResets,
    isResetting,
  }
})
